/* eslint-disable */
import createTwitterLink from "../../utils/createTwitterLink";
import template from "./template";
import ajaxRequest from "./ajaxRequest";

const tradEN = {
  labelShare: "Share on Twitter",
  labelBtn: "Copy text",
  labelBubble: "Text copy"
};

const tradFR = {
  labelShare: "Partager sur Twitter",
  labelBtn: "Copier le texte",
  labelBubble: "Texte copié"
};

/**
 *
 * @param {*} dataCatch
 */
const displayContent = dataCatch => {
  const component = document.querySelector(".cp-live-conf");
  const lang = component.getAttribute("data-lang");
  const container = document.querySelector(".cp-live-conf .teq-container");
  const tweetContainer = document.createElement("div");
  tweetContainer.className = "live-content";

  const listOfTweets = dataCatch.list;
  listOfTweets.forEach((tweet, index) => {
    const textFormated = createTwitterLink(/#(\w+)/g, /@(\w+)/g, tweet.news);
    const textForReTweet = encodeURIComponent(tweet.news.replaceAll("<br>", ""));
    const trad = lang === "fr" ? tradFR : tradEN;

    const newTweet =
      tweet.img !== false
        ? template(
            tweet.display_action,
            tweet.title,
            textFormated,
            textForReTweet,
            trad,
            index,
            tweet.image,
            tweet.image_alt
          )
        : template(
            tweet.display_action,
            tweet.title,
            textFormated,
            textForReTweet,
            trad,
            index
          );

    tweetContainer.insertAdjacentHTML("afterbegin", newTweet);

    const oldTweetContainer = document.querySelector(".live-content");
    oldTweetContainer ? oldTweetContainer.remove() : null;

    container.appendChild(tweetContainer);

    handlerCopyText();
  });
};

/**
 *
 */
const handlerCopyText = () => {
  const allButtons = document.querySelectorAll(".btn-container .copy");
  allButtons.forEach(
    btn => {
      btn.addEventListener("click", () => {
        const ariaLabel = btn.getAttribute("aria-labelledby");
        const infoBubble = btn.lastElementChild;
        const text = document.querySelector(`#${ariaLabel}`);
        navigator.clipboard.writeText(text.innerText);
        infoBubble.classList.add("visible");
        setTimeout(() => {
          infoBubble.classList.remove("visible");
        }, 2000);
      });

      btn.addEventListener("keypress", e => {
        if (e.keyCode === 13 || e.keyCode === 32) {
          const ariaLabel = btn.getAttribute("aria-labelledby");
          const infoBubble = btn.lastElementChild;
          const text = document.querySelector(`#${ariaLabel}`);
          navigator.clipboard.writeText(text.innerText);
          infoBubble.classList.add("visible");
          setTimeout(() => {
            infoBubble.classList.remove("visible");
          }, 2000);
        }
      });
    },
    { once: true }
  );
};

/**
 * Refresh content to display a new tweet each 30sec
 * First we check if
 */
let refreshLiveContent;
const catchNewContent = async () => {
  const newData = await ajaxRequest(".cp-live-conf");
  const confIsLive = newData.status;
  confIsLive === true ? displayContent(newData) : stopLiveRefresh();
};

/**
 * Stop the setInterval who launch the AJAX Request
 */
const stopLiveRefresh = () => {
  clearInterval(refreshLiveContent);
};

/**
 * Init the Component Live Conf
 */
const initLiveConf = async () => {
  const allData = await ajaxRequest(".cp-live-conf");
  displayContent(allData);
  refreshLiveContent = setInterval(catchNewContent, 30000);
};

export default initLiveConf;
